// src/config/env.ts

/**
 * Centralized environment configuration for Stafflunet
 */

// API Keys
export const STAFFLUENT_API_KEY = import.meta.env.VITE_STAFFLUENT_API_KEY;
export const API_KEY = import.meta.env.VITE_OMNI_GATEWAY_API_KEY;
export const OMNISTACK_BASE_URL = import.meta.env.VITE_OMNI_GATEWAY_URL;

// Supabase Configuration
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY;
// VB Configuration
export const VB_URL = import.meta.env.VITE_VB_URL;
export const VB_PARAMS = import.meta.env.VITE_VB_PARAMS;

// Stripe Configuration
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// App Keys
export const STAFF_ADMIN_APP_KEY_PARAM = import.meta.env.VITE_STAFF_ADMIN_APP_KEY_PARAM;
export const STAFF_CLIENT_PORTAL_KEY_PARAM = import.meta.env.VITE_STAFF_CLIENT_PORTAL_KEY_PARAM;

// Google Maps API Key
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export const X_API_KEY = import.meta.env.VITE_X_API_KEY;

export const CLIENT_X_API_KEY = import.meta.env.VITE_CLIENT_X_API_KEY;

export const PUBLIC_OPENAI_API_KEY = import.meta.env.VITE_PUBLIC_OPENAI_API_KEY;
export const PUBLIC_OPENAI_API_BASE_URL = import.meta.env.VITE_PUBLIC_OPENAI_API_BASE_URL;
export const PUBLIC_VOICE_LANGUAGE = import.meta.env.VITE_PUBLIC_VOICE_LANGUAGE;
export const PUBLIC_VOICE_SPEED = import.meta.env.VITE_PUBLIC_VOICE_SPEED;
